export const EntityFields = `
  id
  createdAt: created_at
`

export const EnumFields = `
  name
  description
`
